import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ApplicationService } from '@app/core/services/application/application.service';
import { faBriefcaseMedical, faCalendarAlt, faClock, faMapMarkerAlt, faUserMd } from '@fortawesome/pro-solid-svg-icons';
@Component({
    selector: 'app-application-chain-card',
    templateUrl: './application-chain-card.component.html',
    styleUrls: ['./application-chain-card.component.scss'],
})
export class ApplicationChainCardComponent implements OnChanges {
    faBriefcaseMedical = faBriefcaseMedical;
    faCalendarAlt = faCalendarAlt;
    faClock = faClock;
    faMapMarkerAlt = faMapMarkerAlt;
    faUserMd = faUserMd;

    @Input() application: any;
    @Input() selected: boolean;

    constructor(private applicationService: ApplicationService) {}

    ngOnChanges() {
        /* empty */
    }

    public scrollToDetails() {
        this.applicationService.setScrollApplicationChainEnrolledSubject.next(true);
    }
}
